module.exports = __webpack_public_path__ + "static/media/7.6c616656.jpg";